import {
  CLIENT_NAME_COOKIE,
  EXTERNAL_META,
  NAVIGATION_FROM_APP_CODE,
} from '@/constants/common'

import { getCookieValue, isValidJSON } from './helper'
import getClientCode from './helpers/getClientCode'

export function getClientName() {
  const appCode = getCookieValue(NAVIGATION_FROM_APP_CODE)
  const clientName = getCookieValue(CLIENT_NAME_COOKIE)

  if (clientName) return clientName

  return getClientCode(appCode)
}



export function getExternalMetaData(): Record<string, any> {
  try {
    const data = getCookieValue(EXTERNAL_META)
    const decodedMeta = data && decodeURIComponent(data)
    const metaData = decodedMeta && isValidJSON(decodedMeta)
      ? JSON.parse(decodedMeta)
      : {}
    return metaData
  } catch (error) {
    console.error('Failed to parse external metadata:', error)
    return {}
  }
}